module.exports = __webpack_public_path__ + "img/certificate.0cfb12fb.jpg";